<div *ngIf="state === 'ready'">
  <tcc-table tableClass="table-sm small" 
             [rows]="rows" 
             [columns]="columns" 
              (cellClick)="rowClicked($event)">
  </tcc-table>
</div>